module.exports = __webpack_public_path__ + "static/img/icon_sur_red.cc59d08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_sur_red.png
// module id = q7KH
// module chunks = 1